<template>
	<component
		:is="resolvedComponent"
		v-if="resolvedComponent"
	/>
</template>

<script setup>
const  { data } = defineProps({
	data: {
		type: Object,
		required: true
	}
});
const isDev = process.dev;
const modules = import.meta.glob('./formCustom/*.vue', { eager: true });

// Build component map automatically
const components = Object.entries(modules).reduce((componentArray, [path, module]) => {
	// Extract filename: ./Hero.vue -> Hero
	const componentName = path.replace('./', '').replace('.vue', '')
	// Skip self
	if (componentName === 'FormCustom') {
		return componentArray;
	}

	componentArray[componentName] = module.default;

	return componentArray;
}, {});

// Resolve component based on componentId
const resolvedComponent = computed(() => {
	const component = components[`formCustom/${data.data?.formComponent}`]

	if (!component && isDev) {
		console.warn(`Component "${data.data?.formComponent}" not found. Available:`, Object.keys(components))
	}

	return component || null
});
</script>